import { formatDistance } from 'date-fns';
import { sv } from 'date-fns/locale';

export default function (date: number | Date): string {
  return formatDistance(date, new Date(), { locale: sv, addSuffix: true });
}
